export const FETCH_DIGITAL_GREETING_CARDS =
  'zola/digitalGreetingCards/FETCH_DIGITAL_GREETING_CARDS';
export const FETCH_ORDER_DIGITAL_GREETING_CARD =
  'zola/digitalGreetingCards/FETCH_ORDER_DIGITAL_GREETING_CARD';
export const RECEIVE_DIGITAL_GREETING_CARDS =
  'zola/digitalGreetingCards/RECEIVE_DIGITAL_GREETING_CARDS';
export const RECEIVE_CARD_TEMPLATE = 'zola/digitalGreetingCards/RECEIVE_CARD_TEMPLATE';
export const SET_SELECTED_DGC_UUID = 'zola/digitalGreetingCards/SET_SELECTED_DGC_UUID';
